import { useState } from "react";

import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import { v4 as uuid } from "uuid";

import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import HarnessUserSelect from "../ui/harnessUserSelect.js";
import OmniTextField from "../ui/omniTextField";

const BotpressRunAssessmentDialog = props => {
  const {
    open,
    onClose,
    onAccept,
    dialogTitle = "New Conversation Assessment",
    dialogMessage = "",
    inputLabel = "Comment for Assessment",
    inputPlaceholder = "Why are you rerunning this conversation?",
    defaultValue = "",
    harnessUsers,
    selectedUserIndex,
    onUserChange,
    okMessage = "Ok",
    cancelMessage = "Cancel",
  } = props;

  const [comment, setComment] = useState(defaultValue);

  return (
    <Dialog open={open} onClose={onClose} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogMessage && <DialogMessage>{dialogMessage}</DialogMessage>}

        <Box sx={{ display: "flex", marginTop: 2, marginBottom: 2 }}>
          <HarnessUserSelect
            harnessUsers={harnessUsers}
            value={selectedUserIndex}
            onChange={onUserChange}
          />
        </Box>

        <OmniTextField
          label={inputLabel}
          type="textInput"
          variant="outlined"
          name={uuid()}
          id="assessmentComment"
          rowCount={7}
          multiline
          value={comment}
          onChange={event => setComment(event.target.value)}
          placeholder={inputPlaceholder}
        />
      </DialogContent>
      <DialogActions>
        {cancelMessage && (
          <Button onClick={onClose} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button
          disabled={!comment}
          onClick={() => onAccept(comment)}
          color="secondary"
          variant="contained"
        >
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BotpressRunAssessmentDialog;
